import { render } from "./ReceiveFromRepair.vue?vue&type=template&id=400c60aa"
import script from "./ReceiveFromRepair.vue?vue&type=script&lang=js"
export * from "./ReceiveFromRepair.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__